<div class="container">
  <span class="sectionTitle">Please Login</span>

  <div class="col-md-6">

    <form (ngSubmit)="loginForm(f)" #f="ngForm">
      <div *ngIf="invalidLogin" class="alert alert-danger">
        Invalid username and/or password.
      </div>
      <div class="form-group">
        <input class="form-control mb-2" type="text" id="username" name="username" placeholder="Username" ngModel>
      </div>
      <div class="form-group">
        <input class="form-control mb-3" type="password" id="password" name="password" placeholder="Password" ngModel>
      </div>
      <div class="form-group">
        <button class="btn btn-primary mb-4" type="submit">Login</button>
      </div>
    </form>

  </div>

  <div class="alert alert-info" id="footer">
      <p class="small">This tool is proprietary, and must not be distributed or shared without written consent of Pacific Medical Management Services, Inc.</p>
  </div>

</div>

